import React from 'react';
import { Button, Upload, Icon } from 'antd';

import upload from 'helpers/uploadHelpers';

class UploadFile extends React.Component {
  state = {
    file: '',
    fileList: [],
    uploading: false,
    error: false,
    success: false,
  }

  componentWillUnmount () {
    this.isCancelled = true;
  }

  /**
   * File is the gift for API & fileList is only for user experience.
   * FileList is also good when we want to send multiple files to API,
   * but here we just need the last selected user's file
   */
  handleChange = ({ file, fileList }) => this.setState({
    file,
    fileList: fileList.splice(-1),
    success: false,
  });

  handleSubmit = async () => {
    const {
      endpoint,
      fileType,
      method,
      onSuccess = () => {},
      onFailure = () => {},
    } = this.props;
    const { file } = this.state;

    this.setState({ uploading: true, error: false });

    try {
      const reply = await upload({
        endpoint,
        file,
        fileName: fileType,
        method,
      });
      this.setState({ success: true });
      onSuccess(reply);
    } catch (e) {
      this.setState({
        error: true,
        success: false,
      });
      onFailure(e);
    }

    if (this.isCancelled) return;
    this.setState({ uploading: false, fileList: [], file: '' });
  }

  handleUploadRemoved = () => {
    this.setState({
      file: '',
      error: false,
      success: false,
    });
  }

  /**
   * Disable Antd upload
   */
  uploadWillStart = () => false;

  render () {
    const {
      uploadWillStart,
      handleUploadRemoved,
      handleChange,
      handleSubmit,
    } = this;

    const {
      uploading,
      error,
      success,
      file,
      fileList,
    } = this.state;

    return (
      <div>
        <Upload
          beforeUpload={uploadWillStart}
          onRemove={handleUploadRemoved}
          multiple={false}
          onChange={handleChange}
          fileList={fileList}
        >
          <Button>
            <Icon type="upload" /> Importer un fichier
          </Button>
        </Upload>

        {error && <p>Une erreur est survenue lors de l'envoi du fichier</p>}
        {success && <p><Icon type="check" /> Votre fichier a bien été envoyé</p>}

        <Button
          loading={uploading}
          style={{ marginTop: 10 }}
          onClick={handleSubmit}
          size="large"
          disabled={file.status === 'removed' || !file}
        >
          Envoyer
        </Button>
      </div>
    );
  }
}

export default UploadFile;



// WEBPACK FOOTER //
// ./src/components/UploadAttachment/UploadFile.js